const { default: gql } = require('graphql-tag')

export const enableUserAccessMutation = gql`
  mutation EnableUserAccess($userId: ID!) {
    enableUserAccess(userId: $userId) {
      id
    }
  }
`
